module.exports = __webpack_public_path__ + "img/pancakeswap.ec20bd0d.svg";